import { formatCnpj } from 'utils/federal-tax-id'
import { Check } from '@mui/icons-material'
import { Avatar, Box } from '@mui/material'
import { ITableHeadDTO } from 'data/dtos/components/i-table-head-dto'
import React from 'react'
import Chip from '../table-chip'
import { useStyles } from './styles'

interface ITableFormatBodyContent {
  row: any
  data: ITableHeadDTO
}

const formatString = (fieldContent: string, format: string) => {
  let output = fieldContent

  if (typeof fieldContent == 'boolean' && fieldContent == true) {
    output = 'X'
  }

  if (format == 'cnpj') {
    output = formatCnpj(output)
  }

  return output
}

const TableFormatBodyContent: React.FC<ITableFormatBodyContent> = ({ row, data }) => {
  const classes = useStyles({ color: 'red' })

  if (data.type == 'group') {
    const subTitle: string = formatString(row[data.groupText!.subTitle], 'cnpj')
    const title: string = row[data.groupText!.title]

    if (row[data.groupText!.reference!] != null) {
      const reference: string = row[data.groupText!.reference!]

      return (
        <Box className={classes.group}>
          <Avatar sx={{ width: 40, height: 40 }}>{title.charAt(0).toUpperCase()}</Avatar>
          <Box className={classes.groupText}>
            <span style={{ fontWeight: 600 }}>{title}</span>
            <br />
            <span className={classes.subTitle}>{`${subTitle} (${reference})`}</span>
          </Box>
        </Box>
      )
    }

    return (
      <Box className={classes.group}>
        <Avatar sx={{ width: 40, height: 40 }}>{title.charAt(0).toUpperCase()}</Avatar>
        <Box className={classes.groupText}>
          <span style={{ fontWeight: 600 }}>{title}</span>
          <br />
          <span className={classes.subTitle}>{subTitle}</span>
        </Box>
      </Box>
    )
  }

  if (data.type == 'text') {
    if (!row[data.id] || row[data.id] == '') {
      return '-'
    }

    if (data.id.includes('.')) {
      return formatString(row[data.id.split('.')[0]][data.id.split('.')[1]], data.format ?? '')
    } else if (formatString(row[data.id], data.format ?? '') == 'X') {
      return <Check className={classes.tableIcon} />
    } else {
      return formatString(row[data.id], data.format ?? '')
    }
  }

  if (data.type == 'boolean') {
    const text = row[data.id]

    if (text == 'Ativo') {
      return (
        <Chip
          status={text}
          color='#2E7D32'
        />
      )
    } else if (text == 'Pendente') {
      return (
        <Chip
          status={text}
          color='#BDBDBD'
        />
      )
    } else if (text == 'Convite Enviado') {
      return (
        <Chip
          status={text}
          color='#EF6C00'
        />
      )
    } else if (text == 'Convite Expirado') {
      return (
        <Chip
          status={text}
          color='#BA1A1A'
        />
      )
    }

    return <Chip status={row[data.id]} />
  }

  return row[data.id]
}

export default TableFormatBodyContent
